module.exports = __webpack_public_path__ + "static/media/css.07270c13.png";